import React from "react";
import { Check } from "lucide-react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import FlowBackdrop from "./FlowBackdrop";
import { Page } from "./styles.addUserLookup";
import {
  Dialog,
  DialogAction,
  DialogContent,
  SuccessBackdrop,
  SuccessIcon,
  SuccessTitle,
} from "./styles.addUserSuccess";

const AddUserSuccess = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // Only reachable right after a real add; a cold deep-link must not show success.
  if (!state?.added) {
    return <Navigate to="/manage-users" replace />;
  }

  return (
    <Page>
      <FlowBackdrop />
      <SuccessBackdrop>
        <Dialog role="dialog" aria-modal="true" aria-labelledby="success-title">
          <DialogContent>
            <SuccessIcon>
              <Check aria-hidden="true" />
            </SuccessIcon>
            <SuccessTitle id="success-title">
              User added successfully!
            </SuccessTitle>
          </DialogContent>
          <DialogAction
            type="button"
            onClick={() => navigate("/manage-users", { replace: true })}
          >
            Okay
          </DialogAction>
        </Dialog>
      </SuccessBackdrop>
    </Page>
  );
};

export default AddUserSuccess;
